import type { App } from "@upsquad/server";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type CometChatTokenResponse = App["~Routes"]["auth"]["cometchat-token"]["post"]["response"]["200"];
type CometChatUidResponse = App["~Routes"]["user"][":userId"]["cometchat-uid"]["get"]["response"]["200"];
type CometChatMembersResponse = App["~Routes"]["community"][":communityId"]["cometchat-members"]["get"]["response"]["200"];

export const messageApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCometChatToken: builder.mutation<CometChatTokenResponse, void>({
			query: (): EdenCall<CometChatTokenResponse> => (client) => client.auth["cometchat-token"].post({}),
		}),
		getCometChatUid: builder.query<CometChatUidResponse, string>({
			query:
				(userId): EdenCall<CometChatUidResponse> =>
				(client) =>
					client.user({ userId })["cometchat-uid"].get(),
		}),
		getCommunityCometchatMembers: builder.query<CometChatMembersResponse, string>({
			query:
				(communityId): EdenCall<CometChatMembersResponse> =>
				(client) =>
					client.community({ communityId })["cometchat-members"].get(),
		}),
	}),
});

export const { useGetCometChatTokenMutation, useGetCometChatUidQuery, useGetCommunityCometchatMembersQuery } = messageApi;
